/* */ 
(function(Buffer) {
  'use strict';
  module.exports = $Ref;
  var Pointer = require('./pointer');
  function $Ref() {
    this.path = undefined;
    this.value = undefined;
    this.$refs = undefined;
    this.pathType = undefined;
  }
  $Ref.prototype.exists = function(path, options) {
    try {
      this.resolve(path, options);
      return true;
    } catch (e) {
      return false;
    }
  };
  $Ref.prototype.get = function(path, options) {
    return this.resolve(path, options).value;
  };
  $Ref.prototype.resolve = function(path, options) {
    var pointer = new Pointer(this, path);
    return pointer.resolve(this.value, options);
  };
  $Ref.prototype.set = function(path, value) {
    var pointer = new Pointer(this, path);
    this.value = pointer.set(this.value, value);
  };
  $Ref.is$Ref = function(value) {
    return value && typeof value === 'object' && typeof value.$ref === 'string' && value.$ref.length > 0;
  };
  $Ref.isExternal$Ref = function(value) {
    return $Ref.is$Ref(value) && value.$ref[0] !== '#';
  };
  $Ref.isAllowed$Ref = function(value, options) {
    if ($Ref.is$Ref(value)) {
      if (value.$ref[0] === '#' || !options || options.resolve.external) {
        return true;
      }
    }
  };
  $Ref.isExtended$Ref = function(value) {
    return $Ref.is$Ref(value) && Object.keys(value).length > 1;
  };
  $Ref.dereference = function($ref, resolvedValue) {
    if (resolvedValue && typeof resolvedValue === 'object' && $Ref.isExtended$Ref($ref)) {
      var merged = {};
      Object.keys($ref).forEach(function(key) {
        if (key !== '$ref') {
          merged[key] = $ref[key];
        }
      });
      Object.keys(resolvedValue).forEach(function(key) {
        if (!(key in merged)) {
          merged[key] = resolvedValue[key];
        }
      });
      return merged;
    } else {
      return resolvedValue;
    }
  };
})(require('buffer').Buffer);
